<template>
  <section v-if="products.length > 0" class="">
    <div class="container-lg">
      <div class="section__header">
        <h2 class="mb-[12px] text-heading-2">
        {{ splitTitle(in18['page_recently_bought'])?.first }}
          <span :class="[theme === 'green' && 'text-lime-green ', theme === 'pink' && 'text-hot-pink ', theme === 'amber' && 'text-amber ', theme === 'sky' && 'text-sky-blue ']">
            {{ splitTitle(in18['page_recently_bought'])?.last }}
          </span>
        </h2>
        <div class="section__text !mb-[24px]">{{ in18['page_recently_bought_subtitle'] }}</div>
        <!-- Line after subtitle -->
        <div class="w-full h-1 border-b border-light-gray/25">
          <div class="w-[56%] md:w-[19%] h-1" :class="[theme === 'green' && 'bg-lime-green ', theme === 'pink' && 'bg-hot-pink ', theme === 'amber' && 'bg-amber ', theme === 'sky' && 'bg-sky-blue ']">
          </div>
        </div>
      </div>
      <div class="row  slider-no-dots" data-mobile-slider>
        <div v-for="product in products" class="col-md-3">
          <product-item :product="product"></product-item>
        </div><!-- /.col -->
      </div><!-- /.row -->
    </div><!-- /.container -->
  </section>
</template>

<script>
export default {
  name:  "RecentlyBoughtProducts",
  props: {
    in18: {
      type: Object
    },
    theme: {
      type: String,
      default: 'sky', // Options: green, pink, amber, sky
    },
  },
  data() {
    return {
      products: [],
    }
  },
  mounted() {
    this.fetchRelatedProducts();
  },
  methods: {
    fetchRelatedProducts() {
      axios.get('/api/product/recently-purchased/').then((response) => {
        this.products = response.data.products;
      });
    },
    splitTitle(string) {
      if (!string) return {};
      const words = string.split(" ");
      const last = words.pop();
      return {
        first: words.join(" "),
        last,
      };
    }
  }
}
</script>